import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import ErrorBoundary from './lib/ErrorBoundary';
import LoadingSpinner from './lib/LoadingSpinner';
import AuthForm from './components/AuthForm';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import PublicHome from './pages/PublicHome';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import FAQ from './pages/FAQ';
import About from './pages/About';
import TradingBots from './pages/TradingBots';
import AdminDashboard from './pages/AdminDashboard';
import TradingPairs from './pages/TradingPairs';
import ResetPassword from './pages/ResetPassword';

function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen flex flex-col bg-black">
        <Toaster position="top-right" />
        <BrowserRouter>
          <Suspense fallback={<LoadingSpinner size="lg" className="min-h-screen" />}>
            <Routes>
              <Route path="/" element={<PublicHome />} />
              <Route path="/login" element={<AuthForm mode="login" />} />
              <Route path="/register" element={<AuthForm mode="register" />} />
              <Route path="/reset-password" element={<AuthForm mode="reset" />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/about" element={<About />} />
              <Route path="/" element={<Layout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/trading-bots" element={<TradingBots />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/trading-pairs" element={<TradingPairs />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Route>
            </Routes>
          </Suspense>
        </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
}

export default App;
